/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import {
  NavLink,

  useNavigate,
  useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";


import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,

  FormControl,

  FormControlLabel,
  Button,
  Checkbox,
  Snackbar,
  Alert,

  Autocomplete,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";

const Card = styled(MuiCard)(spacing);


const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);


function FormDetails({ details, id, brands, technologies }) {
  const [is_deleted, setIsDeleted] = useState(details.is_deleted);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const snackRef = useRef(null);
  const navigate = useNavigate();
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const submit = async (values, id) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/plate_inventory/${id}/details`,
        {
          height: values.height,
          width: values.width,
          technology: values.technology._id,
          brand: values.brand._id,
          hsn: values.hsn,
          company: values.company,
          thickness: values.thickness,
          is_deleted,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        navigate("/dashboard/inventory/", {
          state: {
            success: true,
            message: "Plate Details Updated Successfully",
          },
        });
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
      snackRef.current.click();
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          height: details?.height,
          width: details?.width,
          technology: details?.technology,
          brand: details?.brand,
          hsn: details?.hsn,
          company: details?.company,
          thickness: details?.thickness,
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          brand: Yup.object().required("Brand is required"),
          technology: Yup.object().required("Technology is required"),
          height: Yup.string().required("Height is required"),
          width: Yup.string().required("Width is required"),
          hsn: Yup.string().required("HSN/SAC is required"),
          company: Yup.string().required("Company is required"),
          thickness: Yup.string().required("Thickness is required"),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(values, id);
          } catch (error) {
            const message = error.message || "Something went wrong";

            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          values,
        }) => (
          // <></>
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Plate Details Updated Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Update Plate
                        </Typography>
                      </Grid>
                      {/* <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.brand && errors.brand)}
                        >
                          <Select
                            name="brand"
                            id="search-field"
                            value={values.brand}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem value={""} disabled>
                              Select Brand
                            </MenuItem>
                            {brands.map((brand) => {
                              return (
                                <MenuItem value={brand._id}>
                                  {brand.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText>Please Select Brand</FormHelperText>
                        </FormControl>
                      </Grid> */}
                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.brand && errors.brand)}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={brands}
                            value={values?.brand || null}
                            onChange={(event, newValue) => {
                              setFieldValue("brand", newValue || "");
                            }}
                            // inputValue={values?.brand?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.brand && errors.brand)}
                                helperText={touched.brand && errors.brand}
                                label="Select Brand"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl
                          fullWidth
                          error={Boolean(
                            touched.technology && errors.technology
                          )}
                        >
                          <Autocomplete
                            id="combo-box-demo"
                            options={technologies}
                            value={values?.technology || null}
                            onChange={(event, newValue) => {
                              setFieldValue("technology", newValue || "");
                            }}
                            // inputValue={values?.technology?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  touched.technology && errors.technology
                                )}
                                helperText={
                                  touched.technology && errors.technology
                                }
                                label="Select Technology"
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          fullWidth
                          name="height"
                          type="number"
                          value={values.height}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.height && errors.height)}
                          id="search-field"
                          label="Height"
                          helperText={touched.height && errors.height}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="width"
                          type="number"
                          fullWidth
                          value={values.width}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.width && errors.width)}
                          id="search-field"
                          label="Width"
                          helperText={touched.width && errors.width}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="thickness"
                          type="number"
                          fullWidth
                          value={values.thickness}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.thickness && errors.thickness)}
                          id="search-field"
                          label="Thickness"
                          helperText={touched.thickness && errors.thickness}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="company"
                          fullWidth
                          value={values.company}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.company && errors.company)}
                          id="search-field"
                          label="Company"
                          helperText={touched.company && errors.company}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          name="hsn"
                          fullWidth
                          value={values.hsn}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.hsn && errors.hsn)}
                          id="search-field"
                          label="HSN/SAC"
                          helperText={touched.hsn && errors.hsn}
                        />
                      </Grid>

                      <Grid item xs={12} lg={3} md={3}>
                        <FormControl
                          fullWidth
                          component="fieldset"
                          variant="standard"
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={(e) => setIsDeleted(e.target.checked)}
                                checked={is_deleted}
                              />
                            }
                            label={"IS DELETED"}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", margin: "10px" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Submit
                        </Button>
                        {/* <Button
                      style={{ textAlign: "center", background: "red" }}
                      mr={2}
                      variant="contained"
                      color="primary"
                    >
                      Reset
                    </Button> */}
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

const getDetails = async (
  id,
  setLoader,
  setDetails,
  setTechnology,
  setBrand
) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const technologyData = await axios.get(
      `/api/v1/${authData.type}/plate_inventory/technology`,
      config
    );
    const brandData = await axios.get(
      `/api/v1/${authData.type}/plate_inventory/brand`,
      config
    );
    if (technologyData.data.success) {
      setTechnology(technologyData.data.data);
    }
    if (brandData.data.success) {
      setBrand(brandData.data.data);
    }
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory/${id}/details`,
      config
    );
    
    if (data.success) {
      setDetails(data.data);
    }
    setLoader(false);
  } catch (e) {
    console.log(e);
    setLoader(false);
  }
};

function UpdatePlate() {
  const { plate_id } = useParams();
  const [loader, setLoader] = useState(true);
  const [details, setDetails] = useState([]);
  const [technology, setTechnology] = useState([]);
  const [brand, setBrand] = useState([]);

  useEffect(() => {
    const id = plate_id;
    getDetails(id, setLoader, setDetails, setTechnology, setBrand);
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              UPDATE PLATE
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>
              <Typography>Update Plate</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              brands={brand}
              technologies={technology}
              id={plate_id}
              details={details}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default UpdatePlate;
